import { LayoutGrid, Radar, Table2 } from 'lucide-react'

import { LumaNavigationIcon, type NavigationIcon } from '@/components/progetto_arca/LumaIcon'
import type { FeatureFlags } from '@/featureFlags'

export interface NavItem {
  group: string
  id: string
  href?: string
  icon: NavigationIcon
  index: string
  label: string
  statusLabel?: string
  title: string
  showHeader?: boolean
  matches: (pathname: string) => boolean
}

export type RouteKind = 'login' | 'tasks' | 'profile' | 'adminUsers' | 'placeholder'

// The navigation keeps Luma, Dashboard, Pivot, and the funding radar as its product surfaces.
// Luma also exposes direct shortcuts to a new chat and the combined history.
// Every other route stays reachable by URL but hidden.
const INSIGHTS_NAV_ITEM: NavItem = {
  id: 'insights',
  group: 'Il tuo lavoro',
  href: '/insights',
  icon: LumaNavigationIcon,
  index: '01',
  label: 'Luma',
  title: 'Luma — attività e conversazioni',
  matches: (pathname) => pathname === '/' || pathname === '/chat' || pathname === '/insights',
}

const REPORT_NAV_ITEM: NavItem = {
  id: 'report',
  group: 'Il tuo lavoro',
  href: '/report',
  icon: LayoutGrid,
  index: '02',
  label: 'Dashboard',
  title: 'Dashboard — priorità, risultati e approfondimenti',
  matches: (pathname) => pathname.startsWith('/report'),
}

const PIVOT_NAV_ITEM: NavItem = {
  id: 'pivot',
  group: 'Approfondisci',
  href: '/pivot',
  icon: Table2,
  index: '03',
  label: 'Pivot',
  title: 'Pivot — esplorazione tabellare',
  matches: (pathname) => pathname.startsWith('/pivot'),
}

const GRANTS_NAV_ITEM: NavItem = {
  id: 'grants',
  group: 'Approfondisci',
  href: '/bandi',
  icon: Radar,
  index: '04',
  label: 'Bandi e finanziamenti',
  title: 'Bandi e finanziamenti — opportunità da valutare',
  matches: (pathname) => pathname.startsWith('/bandi'),
}

export function isStreetbeatEmail(email: string | undefined): boolean {
  return Boolean(email?.trim().toLowerCase().endsWith('@streetbeat.com'))
}

export function navItemsForFlags(flags: FeatureFlags): NavItem[] {
  void flags
  return [REPORT_NAV_ITEM, INSIGHTS_NAV_ITEM, PIVOT_NAV_ITEM, GRANTS_NAV_ITEM]
}

export function routeKind(pathname: string): RouteKind {
  if (pathname === '/login') return 'login'
  if (pathname === '/' || pathname === '/chat') return 'tasks'
  if (pathname.startsWith('/dashboards')) return 'tasks'
  if (pathname.startsWith('/donors')) return 'tasks'
  if (pathname === '/review') return 'tasks'
  if (pathname.startsWith('/pivot')) return 'tasks'
  if (pathname.startsWith('/data-lab')) return 'tasks'
  if (pathname === '/insights') return 'tasks'
  if (pathname.startsWith('/report')) return 'tasks'
  if (pathname.startsWith('/bandi')) return 'tasks'
  if (pathname === '/organizzazioni') return 'tasks'
  if (pathname === '/donatori-regolari') return 'tasks'
  if (pathname === '/donatori-one-off') return 'tasks'
  if (pathname === '/donatori-one-off-digital') return 'tasks'
  if (pathname === '/profile') return 'profile'
  if (pathname === '/admin/users') return 'adminUsers'
  return 'placeholder'
}
